<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
        <a class="navbar-brand" [routerLink]="['/home']">
            <img src="assets/img1.png" alt="" width="30" height="24" class="d-inline-block align-text-top">
            toDoList</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarScroll"
            aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse main" id="navbarScroll">
            <ul class=" navbar-nav mt-2  ml-auto" style="--bs-scroll-height: 100px;">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/login']">Login</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/signup']">Sign up</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
<div class="container-fluid ">
    <div class="row" *ngIf="error404">
        <div class="col-2 col-sm-2 col-xl-4"></div>
        <div class="col-8 col-sm-8 col-xl-4">
            <img class="error-image" src="/assets/404_animated.gif">
            <p class="text-muted text-center error-text font-weight-normal">Oops! Page not found</p>
        </div>
        <div class="col-2 col-sm-2 col-xl-4"></div>
    </div>
    <div class="row" *ngIf="error500">
        <div class="col-2 col-sm-2 col-xl-4"></div>
        <div class="col-8 col-sm-8 col-xl-4">
            <img class="server-error-image" src="/assets/500_animated.gif">
            <p class="text-muted text-center error-text font-weight-normal">Internal Server Error!</p>
        </div>
        <div class="col-2 col-sm-2 col-xl-4"></div>
    </div>
</div>